import React from "react";
import Routes from "./routes";
import { AuthProvider } from "./context/Authcontext";
import { PlanProvider } from "./context/Plancontext";
import { SponsorProvider } from "./context/Sponsorcontext";

function App() {
  return (
    <AuthProvider>
      <PlanProvider>
        <PlanProvider>
          <SponsorProvider>
            <Routes />
          </SponsorProvider>
        </PlanProvider>
      </PlanProvider>
    </AuthProvider>
  );
}

export default App;
